import * as IoC from 'typescript-ioc';
import { alertServerError } from '../../components/global/modal/alerts-host/alert-templates';
import { ErrorParsing } from './error-parsing';


/**
 * Method Decorator for retrying Api 5xx Errors with delays.
 */
const delayedRetryApi5xxError = (delayedAttempts: number[] = []) => (
    target: object,
    propertyKey: string,
    descriptor: PropertyDescriptor
    ) => {
        const errorParsing = IoC.Container.get(ErrorParsing);
        const originalMethod = descriptor.value;

        descriptor.value = async (apiCallFunction, attemptsLeft, delays = delayedAttempts) => {
            const args = [ apiCallFunction, attemptsLeft ];
            try {
                return await originalMethod.apply(target, args);
            } catch (e) {
                const [ delay, ..._delays ] = delays;
                if (errorParsing.is5xxError(e) && delay) {
                    return await new Promise(resolve => {
                        setTimeout(() => resolve(descriptor.value(...args, _delays)), delay);
                    });
                } else {
                    errorParsing.setAsRetryableApiError(e);
                    throw e;
                }
            }
        };
        return descriptor;
    };

/**
 * Method Decorator for catching Api 5xx Errors.
 */
const catchRetryableApi5xxError = (
    target: object,
    propertyKey: string,
    descriptor: PropertyDescriptor
    ) => {
        const errorParsing = IoC.Container.get(ErrorParsing);
        const originalMethod = descriptor.value;

        descriptor.value = async (...args) => {
            try {
                return await originalMethod.apply(target, args);
            } catch (e) {
                if (errorParsing.isRetryableApiError(e)) {
                    alertServerError('Network Error', 'Something went wrong. Please try again.');
                    errorParsing.unsetRetryableApiError(e);
                }
                throw e;
            }
        };
        return descriptor;
    };

export {
    delayedRetryApi5xxError,
    catchRetryableApi5xxError
};
